// Vendor
import { EventEmitter, SimpleChanges } from '@angular/core';
// Enums
import { SavedItemType } from 'NewAngular/features/components/saved-items/enums/saved-item-type.enum';
import { ITEM_TYPE_INFO_MAP } from 'NewAngular/features/components/saved-items/open-item-modal/constants';
import { OpenItemListComponent } from 'NewAngular/features/components/saved-items/open-item-modal/components/open-item-list/open-item-list.component';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common";
import * as i2 from "../../../../../directives/disabled/disabled.directive";
import * as i3 from "NewAngular/features/components/saved-items/open-item-modal/components/open-item-list/open-item-list.component";
const _c0 = ["ownItemListComponent"];
const _c1 = ["sharedItemListComponent"];
const _c2 = (a0, a1) => ({ active: a0, disabled: a1 });
const _c3 = a0 => ({ active: a0 });
/**
 * Open Item Tabs Component
 *
 * Display two tabs for the owned and shared saved items.
 *
 * Inputs:
 * ownItems: List with the items owned by the user
 * sharedItems: List with the items shared by other users
 * selectOnly: whether items in the list should be able to be edited/deleted or only selected.
 * savedItemType: item type according to SavedItemType
 * sharedWithMeEnabled: whether the Shared tab should be enabled or not
 * itemTypeInfo: Saved item type metadata
 * showRadioButtons: displays a radio button for each item in the list.
 *
 * Outputs:
 * doActionOnItemHandler: Action to be performed when one of the items from any tab is selected.
 */
export class OpenItemTabsComponent {
    constructor() {
        this.ownItems = [];
        this.selectOnly = false;
        this.sharedItems = [];
        this.sharedWithMeEnabled = true;
        this.showRadioButtons = false;
        this.doActionOnItemHandler = new EventEmitter();
        this.itemTypeInfo = null;
        this.myItemsLabel = '';
        this.activeTab = 'own';
    }
    ngOnInit() {
        this.setActiveTab('own');
    }
    ngOnChanges(changes) {
        if (changes.savedItemType && changes.savedItemType.currentValue) {
            const savedItemType = changes.savedItemType.currentValue;
            const itemTypeInfo = ITEM_TYPE_INFO_MAP[savedItemType];
            if (itemTypeInfo != null) {
                this.myItemsLabel = `My ${itemTypeInfo.pluralLabel}`;
                this.itemTypeInfo = itemTypeInfo;
            }
        }
    }
    doActionOnItem(itemAndAction) {
        this.doActionOnItemHandler.emit(itemAndAction);
    }
    setActiveTab(tab) {
        // Set the active tab to shared if a user does not have any of their own items
        this.activeTab = !this.ownItems.length && this.sharedItems.length ? 'shared' : tab;
    }
    clearSelection() {
        this.ownItemListComponent.clearSelection();
        this.sharedItemListComponent.clearSelection();
    }
}
OpenItemTabsComponent.ɵfac = function OpenItemTabsComponent_Factory(t) { return new (t || OpenItemTabsComponent)(); };
OpenItemTabsComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: OpenItemTabsComponent, selectors: [["ycn-open-item-tabs"]], viewQuery: function OpenItemTabsComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0, 5);
        i0.ɵɵviewQuery(_c1, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.ownItemListComponent = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.sharedItemListComponent = _t.first);
    } }, inputs: { ownItems: "ownItems", selectOnly: "selectOnly", savedItemType: "savedItemType", sharedItems: "sharedItems", sharedWithMeEnabled: "sharedWithMeEnabled", showRadioButtons: "showRadioButtons" }, outputs: { doActionOnItemHandler: "doActionOnItemHandler" }, features: [i0.ɵɵNgOnChangesFeature], decls: 13, vars: 30, consts: [["ownItemListComponent", ""], ["sharedItemListComponent", ""], [1, "tabs"], [1, "nav", "nav-tabs", "nav-width-equal"], [1, "nav-item"], ["href", "javascript:void(0)", 1, "nav-link", 3, "click", "ngClass", "textContent"], ["ycnDisabled", "", "href", "javascript:void(0)", 1, "nav-link", 3, "click", "disabled", "ngClass", "textContent"], [1, "tab-content"], [1, "tab-pane", 3, "ngClass"], [3, "itemActionHandler", "isOwner", "items", "itemTypeInfo", "selectOnly", "savedItemType", "showRadioButtons"]], template: function OpenItemTabsComponent_Template(rf, ctx) { if (rf & 1) {
        const _r1 = i0.ɵɵgetCurrentView();
        i0.ɵɵelementStart(0, "div", 2)(1, "ul", 3)(2, "li", 4)(3, "a", 5);
        i0.ɵɵlistener("click", function OpenItemTabsComponent_Template_a_click_3_listener() { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.setActiveTab("own")); });
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(4, "li", 4)(5, "a", 6);
        i0.ɵɵlistener("click", function OpenItemTabsComponent_Template_a_click_5_listener() { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.setActiveTab("shared")); });
        i0.ɵɵelementEnd()()()();
        i0.ɵɵelementStart(6, "div", 7)(7, "div", 8)(8, "ycn-open-item-list", 9, 0);
        i0.ɵɵlistener("itemActionHandler", function OpenItemTabsComponent_Template_ycn_open_item_list_itemActionHandler_8_listener($event) { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.doActionOnItem($event)); });
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(10, "div", 8)(11, "ycn-open-item-list", 9, 1);
        i0.ɵɵlistener("itemActionHandler", function OpenItemTabsComponent_Template_ycn_open_item_list_itemActionHandler_11_listener($event) { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.doActionOnItem($event)); });
        i0.ɵɵelementEnd()()();
    } if (rf & 2) {
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(20, _c2, ctx.activeTab === "own", ctx.ownItems.length === 0))("textContent", ctx.myItemsLabel);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("disabled", !ctx.sharedWithMeEnabled)("ngClass", i0.ɵɵpureFunction2(23, _c2, ctx.activeTab === "shared", ctx.sharedItems.length === 0))("textContent", "Shared with Me");
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(26, _c3, ctx.activeTab === "own"));
        i0.ɵɵadvance();
        i0.ɵɵproperty("isOwner", true)("items", ctx.ownItems)("itemTypeInfo", ctx.itemTypeInfo)("selectOnly", ctx.selectOnly)("savedItemType", ctx.savedItemType)("showRadioButtons", ctx.showRadioButtons);
        i0.ɵɵattribute("data-test-id", ctx.myItemsLabel);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(28, _c3, ctx.activeTab === "shared"));
        i0.ɵɵadvance();
        i0.ɵɵproperty("isOwner", false)("items", ctx.sharedItems)("itemTypeInfo", ctx.itemTypeInfo)("selectOnly", ctx.selectOnly)("savedItemType", ctx.savedItemType)("showRadioButtons", ctx.showRadioButtons);
    } }, dependencies: [i1.NgClass, i2.DisabledDirective, i3.OpenItemListComponent], encapsulation: 2 });
